import { Box, ToggleButton, ToggleButtonGroup, Typography } from '@mui/material';
import { useAppDispatch, useAppSelector } from '../../store';
import { setProvider } from '../../store/slices/avatarSlice';
import type { AvatarProvider } from '../../types/api.types';

export function AvatarProviderToggle() {
  const dispatch = useAppDispatch();
  const avatar = useAppSelector(state => state.avatar);
  const status = useAppSelector(state => state.app.apiStatus);
  const locked = avatar.isConnected || avatar.isConnecting;
  return (
    <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: 1, pb: 1.5 }}>
      <Typography variant="body2">Avatar</Typography>
      <ToggleButtonGroup
        value={avatar.provider}
        exclusive
        size="small"
        disabled={locked}
        aria-label="Avatar provider"
        onChange={(_, provider: AvatarProvider | null) => {
          if (provider && !locked && status?.[provider]) dispatch(setProvider(provider));
        }}
      >
        <ToggleButton value="anam" title={status?.anam ? "Use Anam for your next connection" : "Anam is not configured"} disabled={locked || !status?.anam} aria-label="Use Anam avatar">Anam</ToggleButton>
        <ToggleButton value="tavus" title={status?.tavus ? "Use Tavus for your next connection" : "Tavus is not configured"} disabled={locked || !status?.tavus} aria-label="Use Tavus avatar">Tavus</ToggleButton>
      </ToggleButtonGroup>
      <Typography variant="caption" color="text.secondary">
        {locked ? 'Disconnect to switch avatars' : 'Choose an avatar, then click Speak now'}
      </Typography>
    </Box>
  );
}
